export type ScoreType =
  | 'yesNo'
  | 'yesNoReverse'
  | 'yesNoWithNa'
  | 'yesNoWithNaOrErrors'
  | 'responseTime'
  | 'ownership'
  | 'likert5';

const SCORE_MAPS: Record<ScoreType, Record<string, number | null>> = {
  yesNo: {
    Yes: 1,
    No: 0,
  },
  yesNoReverse: {
    Yes: 0,
    No: 1,
  },
  yesNoWithNa: {
    Yes: 1,
    No: 0,
    'Not Applicable': null,
    'LSE is on later shift': null,
  },
  yesNoWithNaOrErrors: {
    Yes: 1,
    No: 0,
    'Not Applicable': null,
    'Some Errors': null,
  },
  responseTime: {
    'Immediate (<3 mins)': 1,
    'Acceptable (<5 mins)': 1,
    'Slow (>10 mins)': 0,
    'Did not respond': 0,
    'Did not request for assistance': null,
  },
  ownership: {
    'Strong ownership': 1,
    Average: 1,
    Weak: 0,
    Avoidant: 0,
  },
  likert5: {
    '1': 0.2,
    '2': 0.4,
    '3': 0.6,
    '4': 0.8,
    '5': 1,
  },
};

export const getOptionScore = (
  scoringType: ScoreType | undefined,
  option: string | null | undefined
): number | null => {
  if (!scoringType || !option) return null;
  const map = SCORE_MAPS[scoringType];
  if (!map) return null;
  const score = map[option.trim()];
  return typeof score === 'number' ? score : null;
};
